import { AlertTriangle } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'

/**
 * Banner de gating de la reventa cd-2b (docs/120 §6/§7, mockup "brass banner"): se muestra cuando
 * el asesor todavía NO tiene `programas.reventaCd2b.habilitado` — ver `useReventaHabilitada`.
 *
 * Copy LITERAL del mockup aprobado para el caso "resumen" (con las 3 acciones) y "margen" (solo
 * texto, sin acciones — el simulador de abajo sigue siendo visible con datos de catálogo, así que
 * el banner no repite un botón que ya está a la vista). `variante` decide cuál copy usar; se puede
 * forzar título/descripción propios para un caso que el mockup no cubrió (p. ej. "Mis ingresos").
 */
export default function BannerGatingReventa({ variante = 'resumen', titulo, descripcion, mostrarAcciones }) {
  const navigate = useNavigate()

  const COPY = {
    resumen: {
      titulo: 'Certifícate para vender a clientes reales',
      descripcion:
        'Mientras tanto, tu cuenta ya está activa en modo demo: puedes explorar el catálogo completo y practicar cotizaciones sobre tu propia empresa de prueba. Nada de esto se factura ni se envía a un cliente.',
      acciones: true,
    },
    margen: {
      titulo: 'Todavía no puedes fijar margen sobre clientes reales',
      descripcion:
        'Certifícate en al menos un track para habilitar tu propia política de margen. Puedes explorar el simulador de abajo con datos de ejemplo — no se guardará nada hasta que estés certificado.',
      acciones: false,
    },
    ingresos: {
      titulo: 'Todavía no tienes margen de reventa que cobrar',
      descripcion:
        'Tu margen de reventa empieza a acumularse cuando vendas a tu primer cliente real, y eso exige certificarte primero. Tus comisiones del programa de referidos (si las tienes) siguen en la otra pestaña, sin cambios.',
      acciones: false,
    },
  }

  const c = COPY[variante] || COPY.resumen
  const tituloFinal = titulo || c.titulo
  const descripcionFinal = descripcion || c.descripcion
  const conAcciones = mostrarAcciones ?? c.acciones

  return (
    <div className="flex gap-3 items-start rounded-lg border border-accent-200 dark:border-accent-800 bg-accent-50 dark:bg-accent-900/20 px-4 py-3.5">
      <AlertTriangle size={19} className="shrink-0 mt-0.5 text-accent-700 dark:text-accent-300" />
      <div className="min-w-0">
        <p className="text-body-sm font-semibold text-neutral-900 dark:text-neutral-50">{tituloFinal}</p>
        <p className="text-body-sm text-neutral-600 dark:text-neutral-400 mt-1">{descripcionFinal}</p>
        {conAcciones && (
          <div className="flex flex-wrap gap-2 mt-3">
            <Button variant="accent" size="sm" onClick={() => navigate('/reventa/aprendizaje')}>
              Ver mi ruta de estudio
            </Button>
            <Button variant="outline" size="sm" onClick={() => navigate('/reventa/certificacion')}>
              Ir al examen de certificación
            </Button>
            <Button variant="outline" size="sm" onClick={() => navigate('/clientes')}>
              Abrir mi empresa demo
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}
